import type { IMetadata } from '../../domain/channelsuite/common';
import type { IPortalAccountEmailAddress, IPortalAccountPhoneNumber } from '../../domain/channelsuite/user-services/portal-account';
import type { ICustomerBase } from '../../domain/customer-base';
import { ApiBaseService } from '../api-base-service';

export const Endpoint = {
    CUSTOMER_BASES: '/customer-bases',
    PORTAL_ACCOUNT_METADATA: '/portal-account-metadata',
    PORTAL_ACCOUNT_EMAIL: '/portal-account-email',
    PORTAL_ACCOUNT_PHONE_NUMBER: '/portal-account-phone-number',
};

export class CustomerBaseApiService extends ApiBaseService {
    constructor(context = '/delegate/customer-base/v1') {
        super(context);
    }

    async getCustomerBases(): Promise<ICustomerBase[]> {
        return this.http.get<ICustomerBase[]>(Endpoint.CUSTOMER_BASES).then((response) => response.data);
    }

    async setPortalAccountMetadata(metadata: IMetadata[]): Promise<void> {
        return this.http.post(Endpoint.PORTAL_ACCOUNT_METADATA, metadata).then((response) => response.data);
    }

    async setPortalAccountEmail(portalAccountEmailAddress: IPortalAccountEmailAddress): Promise<void> {
        return this.http.post(Endpoint.PORTAL_ACCOUNT_EMAIL, [portalAccountEmailAddress]).then((response) => response.data);
    }

    async deletePortalAccountEmail(): Promise<void> {
        return this.http.post(Endpoint.PORTAL_ACCOUNT_EMAIL, []).then((response) => response.data);
    }

    async setPortalAccountPhoneNumber(portalAccountPhoneNumber: IPortalAccountPhoneNumber): Promise<void> {
        return this.http.post(Endpoint.PORTAL_ACCOUNT_PHONE_NUMBER, [portalAccountPhoneNumber]).then((response) => response.data);
    }

    async deletePortalAccountPhoneNumber(): Promise<void> {
        return this.http.post(Endpoint.PORTAL_ACCOUNT_PHONE_NUMBER, []).then((response) => response.data);
    }
}
